import { useContext } from "react";

import Container from "react-bootstrap/Container";
import ListaCategoriaMovimentacao from "../../../Components/Financeiro/CategoriaMovimentacao/ListaCategoriaMovimentacao";
import "./styles.scss";
import { ThemeContext } from "../../../context/theme-context";

export default function CadCategoriaMovimentacao() {
  const { collapsed } = useContext(ThemeContext);

  return (
    <Container
      className={collapsed ? "contenteLayoutCollapsed" : "contenteLayout"}
    >
      <ListaCategoriaMovimentacao Title="Categorias financeiras" />
    </Container>
  );
}
